import { useState, useEffect } from "react";
import { Login } from '../utils/usersAPI';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoggedUser } from "../features/userSlice";
import { Button, TextField, Grid, Typography, Container, IconButton, FormControlLabel } from '@mui/material';
import { AppbarContainer, AppbarHeader } from '../styles/headerStyle';
import { PersonAdd } from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { AddProductToCart, GetProductsInCartByUserId, UpdateProduct } from "../utils/productInCart";
import { SET_LOGGED_PRODUCTINCART } from "../features/productInCartSlice";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();



  // מאפסים את השדה של הסיסמא כשיש טעות
  useEffect(() => {
    setPassword("");
  }, [error]);

  // useEffect(() => {
  //   // בדיקת פרטי משתמש מקומיים ב-Local Storage
  //   const storedUser = localStorage.getItem('loggedUser');
  //   if (storedUser) {
  //     dispatch(setLoggedUser(JSON.parse(storedUser)));
  //     navigate('/');
  //   }
  // }, [dispatch, navigate]);

  // useEffect(() => {
  //   setPassword("");
  // }, [error]);

  const handleClickReturnBack = () => {
    try {
      navigate("/");
    } catch {
      setError(error.message);
      console.log("page not found");
    }
  };

 const handleClickLogin = async () => {
  if (email === "" || password === "") {
    setError("חובה למלא את כל השדות");
    return;
  }

  if (!/\S+@\S+\.\S+/.test(email)) {
    setError("כתובת האימייל אינה חוקית");
    return;
  }

  const user = {
    Email: email.trim(),
    Password: password.trim(),
  };

  try {
    const res = await Login(user);

    if (res.status === 200) {
      const loggedUserFromServer = res.data;

      dispatch(setLoggedUser(loggedUserFromServer));

      localStorage.setItem("loggedUser", JSON.stringify(loggedUserFromServer));
      localStorage.setItem(
        "isAdmin",
        loggedUserFromServer.tipeUser === "admin" ? "true" : "false"
      );

      if (loggedUserFromServer.tipeUser === "admin") {
        navigate("/admin");
        return;
      }

      const localCart = JSON.parse(localStorage.getItem("cart")) || [];

      const serverCart = await GetProductsInCartByUserId(loggedUserFromServer.id);

for (const item of localCart) {
  const existingItem = serverCart.find(
    (serverItem) =>
      serverItem.productId === item.productId &&
      (serverItem.productOptionId ?? null) === (item.productOptionId ?? null)
  );

 if (existingItem) {
    const newAmount = Number(existingItem.amount || 0) + Number(item.amount || 0);

   console.log("local item:", item);
  console.log("existing server item:", existingItem);
  console.log("new amount:", newAmount)
  await UpdateProduct(existingItem.id, {
    ...existingItem,
    amount: existingItem.amount + item.amount,
  });
} else {
  await AddProductToCart({
    amount: item.amount,
    customerId: loggedUserFromServer.id,
    productId: item.productId,
    productOptionId: item.productOptionId ?? null,
  });
}
}

const updatedServerCart = await GetProductsInCartByUserId(loggedUserFromServer.id);

dispatch(SET_LOGGED_PRODUCTINCART(updatedServerCart));

localStorage.setItem("cart", JSON.stringify(updatedServerCart));
      navigate(location.state?.from || "/");
    } else {
      setError("אחד מהנתונים שגוי");
    }
  } catch (err) {
    console.log("login error:", err);
    setError(err.response?.data || "אירעה שגיאה בהתחברות");
  }
};

  const handleChangeEmail = (event) => {
    setError("");
    let value = event.target.value;
    setEmail(value);
  };

  const handleChangePassword = (event) => {
    setError("");
    setPassword(event.target.value);
  };

  return (
    <>
      {/* <AppbarContainer>
        <AppbarHeader>Welcome to Shine's Stock</AppbarHeader>
      </AppbarContainer> */}
      <Container maxWidth="xs"
        //   sx={{
        //   maxWidth: 830,   // רוחב מקסימלי
        //   width: "100%",   // שלא יתחרבש במסכים קטנים
        //   mx: "auto",      // margin-inline: auto -> מרכז אותו אופקית
        // }} 
        style={{ marginTop: '140px' }}>
        <Typography variant="h4" align="center" gutterBottom>
          התחברות משתמש קיים
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="כתובת מייל"
              name="email"
              type="email"
              fullWidth
              value={email}
              onChange={handleChangeEmail}
              sx={{
                direction: "rtl",
                "& label": {
                  right: 30,
                  left: "auto",
                  transformOrigin: "top right",
                },
                "& legend": {
                  textAlign: "right",
                },
                "& input": {
                  textAlign: "right",
                  paddingRight: "14px",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="סיסמה"
              name="password"
              type={showPassword ? "text" : "password"}
              fullWidth
              value={password}
              onChange={handleChangePassword}
              sx={{
                direction: "rtl",
                "& label": {
                  right: 30,
                  left: "auto",
                  transformOrigin: "top right",
                },
                "& legend": {
                  textAlign: "right",
                },
                "& input": {
                  textAlign: "right",
                  paddingRight: "14px",
                  paddingLeft: "45px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <FormControlLabel
              control={<Checkbox value="remember" style={{ color: "black" }} />}
              label="זכור אותי"
            />
          </Grid>
        </Grid>
        <Button type="button" variant="contained" color="primary" fullWidth onClick={handleClickLogin}>
          התחברות
        </Button>
        <Typography variant="body2" align="center" gutterBottom>
          <br />
          <Link to="/forgot-password">שכחת סיסמה?</Link>
        </Typography>

        {error && <Typography color="error">{error}</Typography>}
        <br></br>
        {/* <Typography variant="body2" align="center" gutterBottom>
          <br></br>

          <Link to="/forgot-password">שכחת סיסמה?</Link>
        </Typography> */}

        {/* <Typography variant="h5" align="center" gutterBottom>
          <br></br>
          <br></br>

          הרשמה למשתמש חדש
          <Button
            color="inherit"
            component={Link}
            to="/signUp"
            startIcon={<PersonAdd style={{ fontSize: 40 }} />}
          >
          </Button> */}
        {/* <Button color='inherit' component={Link} to="/signUp"></Button> */}
        {/* </Typography> */}
        <Typography variant="h5" align="center" gutterBottom>
          <br />
          <br />

          <Button
            color="inherit"
            component={Link}
            to="/signUp"
            endIcon={<PersonAdd style={{ fontSize: 40, marginInlineStart: 8 }} />}
            sx={{
              color: "#0b071df6",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#e91e63"
              }
            }}

          >
            הרשמה למשתמש חדש
          </Button>
        </Typography>


      </Container>
    </>
  );
};

export default SignIn;
